var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEpisodeError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "31px",
    height: "31px",
    viewBox: "0 0 31 31",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Error Episode") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Error-Episode",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-35",
    transform: "translate(-0.400743, 0.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.8948054,27 L5.92680544,27 C4.81480544,27 3.91080544,26.096 3.91080544,24.984 L3.91080544,5.016 C3.91080544,3.904 4.81480544,3 5.92680544,3 L25.8958054,3 C27.0068054,3 27.9108054,3.904 27.9108054,5.016 L27.9108054,24.985 C27.9108054,26.096 27.0068054,27 25.8948054,27 Z M5.92680544,4 C5.36680544,4 4.91080544,4.456 4.91080544,5.016 L4.91080544,24.985 C4.91080544,25.544 5.36680544,26 5.92680544,26 L25.8958054,26 C26.4548054,26 26.9108054,25.544 26.9108054,24.984 L26.9108054,5.016 C26.9108054,4.456 26.4548054,4 25.8948054,4 L5.92680544,4 Z",
    id: "Shape",
    stroke: "#000000",
    strokeWidth: 0.5,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9108054,9.5 L8.91080544,9.5 C8.63480544,9.5 8.41080544,9.276 8.41080544,9 C8.41080544,8.724 8.63480544,8.5 8.91080544,8.5 L10.9108054,8.5 C11.1868054,8.5 11.4108054,8.724 11.4108054,9 C11.4108054,9.276 11.1868054,9.5 10.9108054,9.5 Z",
    id: "Path",
    stroke: "#000000",
    strokeWidth: 0.5,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9108054,13.5 L8.91080544,13.5 C8.63480544,13.5 8.41080544,13.276 8.41080544,13 C8.41080544,12.724 8.63480544,12.5 8.91080544,12.5 L10.9108054,12.5 C11.1868054,12.5 11.4108054,12.724 11.4108054,13 C11.4108054,13.276 11.1868054,13.5 10.9108054,13.5 Z",
    id: "Path",
    stroke: "#000000",
    strokeWidth: 0.5,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9108054,17.5 L8.91080544,17.5 C8.63480544,17.5 8.41080544,17.276 8.41080544,17 C8.41080544,16.724 8.63480544,16.5 8.91080544,16.5 L10.9108054,16.5 C11.1868054,16.5 11.4108054,16.724 11.4108054,17 C11.4108054,17.276 11.1868054,17.5 10.9108054,17.5 Z",
    id: "Path",
    stroke: "#000000",
    strokeWidth: 0.5,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9108054,21.5 L8.91080544,21.5 C8.63480544,21.5 8.41080544,21.276 8.41080544,21 C8.41080544,20.724 8.63480544,20.5 8.91080544,20.5 L10.9108054,20.5 C11.1868054,20.5 11.4108054,20.724 11.4108054,21 C11.4108054,21.276 11.1868054,21.5 10.9108054,21.5 Z",
    id: "Path",
    stroke: "#000000",
    strokeWidth: 0.5,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9108054,9.5 L14.9108054,9.5 C14.6348054,9.5 14.4108054,9.276 14.4108054,9 C14.4108054,8.724 14.6348054,8.5 14.9108054,8.5 L22.9108054,8.5 C23.1868054,8.5 23.4108054,8.724 23.4108054,9 C23.4108054,9.276 23.1868054,9.5 22.9108054,9.5 Z",
    id: "Path",
    stroke: "#000000",
    strokeWidth: 0.5,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9108054,13.5 L14.9108054,13.5 C14.6348054,13.5 14.4108054,13.276 14.4108054,13 C14.4108054,12.724 14.6348054,12.5 14.9108054,12.5 L22.9108054,12.5 C23.1868054,12.5 23.4108054,12.724 23.4108054,13 C23.4108054,13.276 23.1868054,13.5 22.9108054,13.5 Z",
    id: "Path",
    stroke: "#000000",
    strokeWidth: 0.5,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9108054,17.5 L14.9108054,17.5 C14.6348054,17.5 14.4108054,17.276 14.4108054,17 C14.4108054,16.724 14.6348054,16.5 14.9108054,16.5 L22.9108054,16.5 C23.1868054,16.5 23.4108054,16.724 23.4108054,17 C23.4108054,17.276 23.1868054,17.5 22.9108054,17.5 Z",
    id: "Path",
    stroke: "#000000",
    strokeWidth: 0.5,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9108054,21.5 L14.9108054,21.5 C14.6348054,21.5 14.4108054,21.276 14.4108054,21 C14.4108054,20.724 14.6348054,20.5 14.9108054,20.5 L22.9108054,20.5 C23.1868054,20.5 23.4108054,20.724 23.4108054,21 C23.4108054,21.276 23.1868054,21.5 22.9108054,21.5 Z",
    id: "Path",
    stroke: "#000000",
    strokeWidth: 0.5,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#FFFFFF",
    strokeWidth: 3,
    transform: "translate(15.910805, 15.000000) rotate(-315.000000) translate(-15.910805, -15.000000) ",
    x: -5.5,
    y: 12.1926141,
    width: 42.8216109,
    height: 5.61477177,
    rx: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEpisodeError);
export default __webpack_public_path__ + "static/media/episode-error.47b1a5b39aff4b174b799fdf1b6f2985.svg";
export { ForwardRef as ReactComponent };